<div style="display: flex; justify-content: center; align-items: center; height: 100vh; background: #f0f2f5;">
    <nz-result nzStatus="error" nzTitle="Access Denied"
        nzSubTitle="Access to this application has been suspended due to non-payment. Please contact your administrator or accounts team to resolve this.">
        <div nz-result-extra>
            <button nz-button nzType="primary" (click)="logout()">Logout</button>
        </div>
    </nz-result>
</div>
